exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*\r\n * Application global variables.\r\n */\n.success-title {\n  color: #27B473;\n  font-size: 28px; }\n.modal-title {\n  color: #5f5f5f;\n  font-size: 28px; }\n.circle {\n  width: 100px;\n  height: 100px;\n  background: white;\n  border-radius: 50px;\n  -webkit-box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);\n          box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);\n  margin: 0 auto; }\n.coupon-number {\n  padding-top: 36%;\n  padding-left: 17%;\n  float: left;\n  color: #56A9D4;\n  font-size: 26px;\n  font-weight: bolder; }\n.coupon-icon {\n  padding-top: 33%;\n  padding-left: 5%;\n  background-repeat: no-repeat;\n  float: left; }\n.description-text {\n  text-size: 8px;\n  color: #9B9B9B; }\n.bottom-content {\n  position: absolute;\n  bottom: 1rem; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// d:/workspace/wynk_web_shoppings_3_prod/src/app/shopping-promotion/shopping-promotion.component.scss
// module id = ../../../../../src/app/shopping-promotion/shopping-promotion.component.scss
// module chunks = main